import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async updateExistingCategory(context, payload = {}) {
        //payload : {params:{categoryId: "23412123"}, data:DAM Users JSON schema}

        try {
            let resp = await axios.put(`${Constants.categoriesUrl}/${payload.params._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateExistingCategory][Store][Category update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                context.commit("setCategoriesinfo", {})
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateExistingCategory][Store][Error occured while updating Category--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async deleteExistingCategory(context, payload = {}) {
        //payload : {params:{categoryId: "23412123"}, data:DAM Users JSON schema}

        try {
            let resp = await axios.delete(`${Constants.categoriesUrl}/${payload.params._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[deleteExistingCategory][Store][Category Delete resp-->${resp.status}]`
                );
                context.commit("setCategoriesinfo", {})
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[deleteExistingCategory][Store][Error occured while deleting Category--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async getCategoryInfoFromServer(context, payload = {}) {
        //payload : {params:{groupId:"3422344231"}}

        try {
            let categoryId = payload.params._id
            delete payload.params._id
            let resp = await axios.get(`${Constants.categoriesUrl}/${categoryId}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getCategoryInfoFromServer][Store][Error occured while getting Category info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    }
};